module.exports = __webpack_public_path__ + "files/e23c300d3cba31e57d540954eadb7a60.png";